
/**
 * @param {string} text Must resolve to HTML or the output may be unexpected
 *
 * @return {HTMLElement}
 */
export function textToHTML( text ) {
    const container = document.createElement( 'div' );
    container.innerHTML = text;
    //@ts-ignore Realistically only going to be htmlelement
    return container.firstElementChild;
}